import React from "react";
import "./eCommerce.css";

export default function Ecommerce() {
  return (
    <div className="eComContainer">
      <div className="ecomTop">
        <div className="item item1">1</div>
        <div className="item item2">2</div>
      </div>
      <div className="ecomMiddle1">
        <div className="item item3">3</div>
        <div className="item item4">4</div>
        <div className="item item5">5</div>
        <div className="item item6">6</div>
        <div className="item item7">7</div>
      </div>
      <div className="ecomMiddle2">
        <div className="item item8">8</div>
        <div className="itemRight">
          <div className="item item9">9</div>
          <div className="item item10">10</div>
          <div className="item item11">11</div>
          <div className="item item12">12</div>
        </div>
      </div>
      <div className="ecomBottom">
        <div className="item item13">13</div>
        <div className="item item14">14</div>
      </div>
    </div>
  );
}
